import { Component } from '@angular/core';

@Component({
  selector: 'app-form-of-pension-payment-married-info',
  templateUrl: './form-of-pension-payment-married-info.component.html',
  styleUrls: ['./form-of-pension-payment-married-info.component.scss']
})
export class FormOfPensionPaymentMarriedInfoComponent {

}
